/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ presetName: NonNullable<unknown> }} Styles_Delete_Preset_Confirm_TextInputs */

const en_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.presetName}"?`)
};

const fr_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir supprimer "${i?.presetName}"?`)
};

const de_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.presetName}" wirklich löschen?`)
};

const it_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare "${i?.presetName}"?`)
};

const ru_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.presetName}"?`)
};

const es_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar "${i?.presetName}"?`)
};

const zh_cn2_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除“${i?.presetName}”吗？`)
};

const ja_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.presetName}」を削除してもよろしいですか?`)
};

const hi_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.presetName}" को हटाना चाहते हैं?`)
};

const pt_pt2_styles_delete_preset_confirm_text = /** @type {(inputs: Styles_Delete_Preset_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.presetName}"?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{presetName}\"?" |
*
* @param {Styles_Delete_Preset_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_delete_preset_confirm_text = /** @type {((inputs: Styles_Delete_Preset_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Delete_Preset_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_delete_preset_confirm_text(inputs)
	if (locale === "de") return de_styles_delete_preset_confirm_text(inputs)
	if (locale === "it") return it_styles_delete_preset_confirm_text(inputs)
	if (locale === "ru") return ru_styles_delete_preset_confirm_text(inputs)
	if (locale === "es") return es_styles_delete_preset_confirm_text(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_delete_preset_confirm_text(inputs)
	if (locale === "ja") return ja_styles_delete_preset_confirm_text(inputs)
	if (locale === "hi") return hi_styles_delete_preset_confirm_text(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_delete_preset_confirm_text(inputs)
	return en_styles_delete_preset_confirm_text(inputs)
});